import { FC, useEffect, useState } from "react";
import { GenericStoryElementComponentProps, GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import { StoryElement } from "../storyelements-management/story-element";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Button, Link, MenuItem, Paper, Select, TextField } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useDebounce } from "@uidotdev/usehooks";

const CATEGORIES = [
    "ANSP MESO",
    "ANSP Procédures",
    "ANSP Général",
    "Evénements",
    "Statistiques",
    "Aéroports",
    "Innovation"
];

const DSNAChannelSetter:FC<GenericStoryElementComponentProps> = ({ storyElement }) => {

    const [categories, setCategories] = useState(storyElement.dsnaCategories?storyElement.dsnaCategories:[]);
    const [titleOverride, setTitleOverride] = useState(storyElement.dsnaTitleOverride?storyElement.dsnaTitleOverride:"");
    const [imageURL, setImageURL] = useState(storyElement.dsnaImageURL?storyElement.dsnaImageURL:"");
 

    const titleOverrideDebounced = useDebounce(titleOverride, 1000);
    const imageURLDebounced = useDebounce(imageURL, 1000);
    const categoriesDebounced = useDebounce(categories, 1000);

    useEffect(() => {
        const newStoryElement = {
            ... storyElement,
            dsnaCategories: categoriesDebounced,
            dsnaTitleOverride: titleOverrideDebounced,
            dsnaImageURL: imageURLDebounced,
        }

        StorylineServerProxy.updateStoryElement(newStoryElement);
    }, [titleOverrideDebounced, imageURLDebounced, categoriesDebounced])

    function handleCategoriesChanged(event: any){
        setCategories(event.target.value);
    }

    function handleTitleOverrideChanged(event: any){
        setTitleOverride(event.target.value);
    }

    function handleImageURLChanged(event: any){
        setImageURL(event.target.value);
    }


    return(
        <>
            <Paper elevation={6}  sx={{ padding: 3, margin:0}}>
                <Link href={ storyElement.link } target="child">{ storyElement.title }</Link>
                <br/>
                { storyElement.description }
                <br/><br/>
            <Select multiple sx={{ width: 1/3, marginRight:2 }} value={categories} onChange={handleCategoriesChanged}>
                    <MenuItem value="-">-</MenuItem>
                    {
                        CATEGORIES.map(category => {
                            return <MenuItem value={category}>{category}</MenuItem>
                        })
                    }
                </Select>
                <TextField value={titleOverride} onChange={handleTitleOverrideChanged} sx={{ width: 9/10 }} placeholder="Title override"></TextField>
                <TextField value={imageURL} onChange={handleImageURLChanged} sx={{ width: 9/10 }} placeholder="Image url"></TextField>
                <Link href={ imageURL } target="imageChild"><OpenInNewIcon></OpenInNewIcon></Link>

            </Paper>
        </>
    )
}

export default function DSNAChannelSetterPage(){

    let [storyElements, setStoryElements] = useState([] as StoryElement[]);

    useEffect(() => {
        StorylineServerProxy.getFilteredStoryElements({type: "News"}, 50, 0).then(elements => { setStoryElements(elements)} )
    }, []);

    return (
        <GenericStorylineElementsList storyElements={storyElements} Component={DSNAChannelSetter} updateListFromServer={null} />
    )
}
